import { APP_INITIALIZER, ApplicationConfig, importProvidersFrom, provideBrowserGlobalErrorListeners, provideZoneChangeDetection, isDevMode } from '@angular/core';
import { provideRouter } from '@angular/router';
import { registerLocaleData } from '@angular/common';
import { provideAnimations } from '@angular/platform-browser/animations';
import { routes } from './app.routes';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { JwtInterceptor } from './interceptors/jwt.interceptor';
import { ErrorInterceptor } from './interceptors/error.interceptor';
import { ToastrModule } from 'ngx-toastr';
import { KeycloakService } from './services/keycloak.service';
import { provideServiceWorker } from '@angular/service-worker';
import { environment } from '../environments/environment';
import localeEsCL from "@angular/common/locales/es-CL";
import { LOCALE_ID } from '@angular/core';

export function kcFactory(keycloakService: KeycloakService) {
  return () => keycloakService.init();
}

registerLocaleData(localeEsCL);

export const appConfig: ApplicationConfig = {
  providers: [
  provideBrowserGlobalErrorListeners(),
  provideZoneChangeDetection({ eventCoalescing: true }),
  provideRouter(routes),
  provideHttpClient(withInterceptorsFromDi()),

  {
    provide: HTTP_INTERCEPTORS,
    useClass: JwtInterceptor,
    multi: true
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: ErrorInterceptor,
    multi: true
  },
  {
    provide: APP_INITIALIZER,
    useFactory: kcFactory,
    deps: [KeycloakService],
    multi: true,
  },
  { provide: LOCALE_ID, useValue: 'es-CL' },
  provideAnimations(),

  importProvidersFrom(
    ToastrModule.forRoot({
      enableHtml: true,
      positionClass: 'toast-top-right',
      timeOut: 3000,
      preventDuplicates: true,
    })
  ),
  provideServiceWorker('ngsw-worker.js', {
    //enabled: !isDevMode()
    enabled : environment.SW,
    registrationStrategy: 'registerWhenStable:30000'
  })
]
};
